import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SET_API_ROOT_INDEX, SET_USE_PROD, SET_AD_BLOCKER } from '../actions/types';
var initialState = {
  value: 0,
  useProd: null
};
export var apiRootReducer = function apiRootReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_API_ROOT_INDEX:
      return _objectSpread(_objectSpread({}, state), {}, {
        value: action.payload
      });
    case SET_USE_PROD:
      return _objectSpread(_objectSpread({}, state), {}, {
        useProd: action.payload
      });
    case SET_AD_BLOCKER:
      return _objectSpread(_objectSpread({}, state), {}, {
        adBlockerEnabled: action.payload
      });
    default:
      return state;
  }
};